import * as React from "react";
import { styled } from "@mui/material";
import { Link } from "react-router-dom";

//region [[ Styles ]]

const FiveHundredView = styled("div")({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  textAlign: "center",
});

const Title = styled("h1")({});

const ErrorContent = styled("p")({});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface FiveHundredProps {
  errorText?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const FiveHundred = ({ ...props }: FiveHundredProps) => {
  return (
    <FiveHundredView>
      <Title>
        Well this is awkward &nbsp;
        <span role="img" aria-label="embraced emoji">
          😳
        </span>
      </Title>
      <ErrorContent>
        {props.errorText || (
          <>
            seems like something went terribly wrong
            <span role="img" aria-label="sad smiley face">
              :\
            </span>
            <br />
            we are very sorry you had to experience this, please try again...
            <br />
            <br />
            <br />
            if this error continues please help us by contacting:
            <Link to={"mailto:bugs@kahun.com"}>bugs@kahun.com</Link> with a
            screen shoot and a link and we will make sure this won't happen
            again &nbsp;
            <span role="img" aria-label="angel emoji">
              😇
            </span>
          </>
        )}
      </ErrorContent>
    </FiveHundredView>
  );
};
